import React from 'react'
import { ONGLET_GESTION_TACHE } from '../../../utils/constants'
import moment from 'moment'
import { refreshHeaderRessources } from './gestionTachesApi'
import { LocalDate } from '../../../utils/date/local-date'
import { DateFormat, DateUnit } from '../../../utils/date/model/date'

const gestionTacheContextType = {
	onglet: ONGLET_GESTION_TACHE.SYNTHESE,
	setOnglet: (onglet) => {
	},

	semaineSelection: LocalDate.now().startOf(DateUnit.week).format(DateFormat.REVERSE_SHORT_DATE),
	setSemaineSelection: (semaineSelection) => {
	},

	semaineCourante: null,
	setSemaineCourante: (semaine) => {
	},

	selectedContrats: new Set(),
	setSelectedContrats: (contrat) => {
	},

	jourSelection: LocalDate.now().format(DateFormat.REVERSE_SHORT_DATE),
	setJourSelection: (jourSelection) => {
	},

	headerData: {},
	refreshHeaderData: () => {
	},

	isResultat: false,
	setIsResultat: (isResultat) => {
	}
}

export const GestionTacheContext = React.createContext(gestionTacheContextType)

export const useGestionTacheContext = () => React.useContext(GestionTacheContext)

const GestionTacheProvider = ({ children }) => {
	const [onglet, setOnglet] = React.useState(ONGLET_GESTION_TACHE.SYNTHESE)
	const [semaineSelection, setSemaineSelection] = React.useState(LocalDate.now().startOf(DateUnit.week).format(DateFormat.REVERSE_SHORT_DATE))
	const [jourSelection, setJourSelection] = React.useState(LocalDate.now().format(DateFormat.REVERSE_SHORT_DATE))
	const [semaineCourante, setSemaineCourante] = React.useState(null)
	const [headerData, setHeaderData] = React.useState({})
	const [selectedContrats, setSelectedContrats] = React.useState(new Set())
	const [isResultat, setIsResultat] = React.useState(false)

	/**
	 * Raffraîchit le header de l'onglet ressources
	 * Fonction appelée sur l'onglet ressources et sur les actions de la semaine (initialisation, switch, validation)
	 */
	const fetchHeaderRessouces = React.useCallback((onglet, date, resultatParam = null) => {
		if (onglet === ONGLET_GESTION_TACHE.RESSOURCES) {
			const res = resultatParam === null ? isResultat : resultatParam
			const dynamicFilters = { semaine: moment(date).format('YYYY-MM-DD'), contrats: [...selectedContrats], isResultat: res }
			return refreshHeaderRessources(dynamicFilters)
				.then(setHeaderData)
		}

		return Promise.resolve()
	}, [selectedContrats, isResultat])

	/** Prends en compte le switch d'onglet dans n'importe quel ordre */
	const handleOngletChange = React.useCallback((newOnglet) => {
		setOnglet(newOnglet)
		setSelectedContrats(new Set())
		return fetchHeaderRessouces(newOnglet, semaineSelection)
	}, [fetchHeaderRessouces, semaineSelection])

	const handleSelectSemaine = React.useCallback(semaine => {
		setSemaineSelection(semaine)
		return fetchHeaderRessouces(onglet, semaine)
	}, [])

	const handleSelectJour = React.useCallback(jour => {
		setJourSelection(jour)
		return fetchHeaderRessouces(onglet, jour)
	}, [fetchHeaderRessouces, onglet])

	const handleChangeStep = React.useCallback(resultat => {
		setIsResultat(resultat)
		return fetchHeaderRessouces(onglet, semaineSelection, resultat)
	}, [fetchHeaderRessouces, semaineSelection, onglet])

	return (
		<GestionTacheContext.Provider value={{
			onglet,
			setOnglet: handleOngletChange,
			semaineSelection,
			setSemaineSelection: handleSelectSemaine,
			semaineCourante,
			setSemaineCourante,
			setSelectedContrats,
			selectedContrats,
			jourSelection,
			setJourSelection: handleSelectJour,
			headerData,
			refreshHeaderData: () => fetchHeaderRessouces(onglet, semaineSelection),
			isResultat,
			setIsResultat: handleChangeStep
		}}>
			{children}
		</GestionTacheContext.Provider>
	)
}


export default GestionTacheProvider
